import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function LegalPage({ eyebrow, title, updated, children, testid }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 py-12 sm:py-16" data-testid={testid}>
        <div className="font-mono text-[11px] uppercase tracking-widest text-[#00E676]">{eyebrow}</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-3">{title}</h1>
        <div className="font-mono text-xs uppercase tracking-widest text-[#606872] mt-3">Last updated {updated}</div>
        <article className="legal-prose mt-10 space-y-8 text-[#A0A7B0] leading-relaxed">{children}</article>
      </main>
      <Footer />
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-lg md:text-xl font-bold text-[#F4F1EA] tracking-tight">{title}</h2>
      <div className="mt-3 space-y-3 text-sm sm:text-base">{children}</div>
    </section>
  );
}
